export const SET_MODAL = 'modal/SET_MODAL';
